import { render, staticRenderFns } from "./PreviewFormsAFF.vue?vue&type=template&id=1116d140"
import script from "./PreviewFormsAFF.vue?vue&type=script&lang=ts"
export * from "./PreviewFormsAFF.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports